import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

const Booking = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language.startsWith('zh') ? 'zh' : 'en';
  const location = useLocation();
  const isCustom = new URLSearchParams(location.search).get('custom') === '1';

  const [form, setForm] = useState({
    name: '',
    email: '',
    customAmount: '',
    customNote: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const cleanedAmount = form.customAmount.replace(/[^\d.]/g, '');
      const payload = {
        name: form.name,
        email: form.email,
        customAmount: cleanedAmount,
        customNote: form.customNote,
      };

      const response = await axios.post(`${import.meta.env.VITE_API_URL}/api/create-checkout-session`, payload);
      const data = await response.data;

      const stripe = await stripePromise;
      await stripe.redirectToCheckout({ sessionId: data.sessionId });

    } catch (err) {
      setError(err.message || t('booking.error'));
      setLoading(false);
    }
  };

  if (!isCustom) {
    return (
      <div className="pt-24 pb-12 min-h-screen flex justify-center items-start bg-gray-50">
        <div className="bg-white shadow-sm rounded-lg p-8 text-center border border-blue-100">
          <h2 className="text-xl font-bold text-gray-700 mb-4">
            {lang === 'zh' ? '请从首页选择房型进行预订' : 'Please select a room from the homepage'}
          </h2>
          <a href="/" className="text-blue-600 hover:underline">
            {lang === 'zh' ? '返回首页' : 'Back to Homepage'}
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {t('booking.online')}
          </h2>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4 bg-white p-8 rounded-lg shadow-sm border border-blue-100">
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder={t('booking.name')}
            className="w-full border border-blue-200 p-2 rounded-md focus:ring-2 focus:ring-blue-300 focus:border-blue-400 transition outline-none"
            required
          />
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder={t('booking.email')}
            className="w-full border border-blue-200 p-2 rounded-md focus:ring-2 focus:ring-blue-300 focus:border-blue-400 transition outline-none"
            required
          />
          <input
            type="text"
            name="customAmount"
            value={form.customAmount}
            onChange={handleChange}
            placeholder={t('booking.customAmount')}
            className="w-full border border-blue-200 p-2 rounded-md focus:ring-2 focus:ring-blue-300 focus:border-blue-400 transition outline-none"
            required
          />
          <textarea
            name="customNote"
            value={form.customNote}
            onChange={handleChange}
            placeholder={t('booking.note')}
            className="w-full border border-blue-200 p-2 rounded-md focus:ring-2 focus:ring-blue-300 focus:border-blue-400 transition outline-none"
          />
          {error && <p className="text-red-500 text-sm bg-red-50 border border-red-200 rounded p-2 text-center">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-700 text-white py-2 rounded-md hover:bg-blue-800 transition-colors font-semibold shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-300 disabled:bg-blue-300"
          >
            {loading ? t('loading') : t('booking.pay')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Booking;
